import { FaPlaneDeparture, FaShip, FaTools, FaShieldAlt, FaDesktop } from "react-icons/fa";
import competence1 from "../../assets/Competences/1.png";
import competence2 from "../../assets/Competences/2.png";
import competence3 from "../../assets/Competences/3.png";
import competence4 from "../../assets/Competences/4.png";
import competence5 from "../../assets/Competences/5.png";
import competence6 from "../../assets/Competences/6.png";
import competence7 from "../../assets/Competences/7.png";
import competence8 from "../../assets/Competences/8.png";
import competence9 from "../../assets/Competences/9.png";
import competence10 from "../../assets/Competences/10.jpg";
import competence11 from "../../assets/Competences/11.png";
import competence12 from "../../assets/Competences/12.png";
import competence13 from "../../assets/Competences/13.png";
import competence14 from "../../assets/Competences/14.png";
import competence15 from "../../assets/Competences/15.png";
import competence16 from "../../assets/Competences/16.jpg";
import competence17 from "../../assets/Competences/17.jpg";
import { Competence } from "../../shared/types";

const competencesData: Competence[] = [
  {
    id: 1,
    icon: <FaPlaneDeparture />,
    color: "text-palette1",
    title: "AEROSPACE",
    shortDescription:
      "DREAM supports aerospace industry in meeting 2050 flightpath goals & green deal by enhancing vehicle performance & reducing environmental impact.",
    longDescription:
      "DREAM aims to support the national and European aerospace industry in achieving the 2050 flightpath goals and the green deal by enhancing the performance of air transport vehicles and mitigating their impact on the environment. Dream operates in fixed-wing and rotary-wing aircraft, drones, space launchers and engines.",
    items: [
      {
        id: 1,
        title: "Fixed Wing Aircraft",
        shortDescription:
          "DREAM has the skills and tools to numerically design, study, evaluate and optimise the aerodynamic performance of complex aircraft configurations or one of their components.",
        image: competence1,
        longDescription:
          "DREAM has the skills and tools to numerically design, study, evaluate and optimise the aerodynamic performance of complex aircraft configurations or one of their components.",
        items:  [
          {
            id: 1,
            title: "Improving Aerodynamic Performance",
            shortDescription:
              "Expertise in reducing aircraft drag through aerodynamic shape optimization, minimizing interferences and maximizing their aerodynamic performance.",
            image: competence4,
            longDescription:
              "Expertise in reducing aircraft drag through aerodynamic shape optimization, minimizing interferences and maximizing their aerodynamic performance.",
            items: [],
          },
          {
            id: 2,
            title: "Laminar Flow Technology",
            shortDescription:
              "Expertise in the design of swept laminar wings or components (Vertical and horizontal tail plane, etc.) by using an approach based on boundary layer, linear stability and eN method coupling",
            image: competence5,
            longDescription:
              "Expertise in the design of swept laminar wings or components (Vertical and horizontal tail plane, etc.) by using an approach based on boundary layer, linear stability and eN method coupling",
            items: [],
          },
          {
            id: 3,
            title: "Laminar Flow Extension",
            shortDescription:
              "The remarkable background in laminar flow technology makes it possible to predict the transition from laminar to turbulent flows thanks to the coupling between linear stability analysis and the eN method.",
            image: competence6,
            longDescription:
              "The remarkable background in laminar flow technology makes it possible to predict the transition from laminar to turbulent flows thanks to the coupling between linear stability analysis and the eN method.",
            items: [],
          },
        ],
      },
      {
        id: 2,
        title: "Rotary Wing Aircraft",
        shortDescription:
          "Our company offers expertise in designing, evaluating, and improving the aerodynamic performance of helicopters, tiltrotors, and other fast rotorcraft configurations for national and European businesses.",
        image: competence2,
        longDescription:
          "Our company offers expertise in designing, evaluating, and improving the aerodynamic performance of helicopters, tiltrotors, and other fast rotorcraft configurations for national and European businesses.",
        items: [
          {
            id: 1,
            title: "Improving Aerodynamic Performance",
            shortDescription:
              "Expertise in aerodynamic shape optimization of complex rotary wing configurations such the tilt rotor or compound helicopter by minimizing interferences and maximizing their aerodynamic performance.",
            image: competence7,
            longDescription:
              "Expertise in aerodynamic shape optimization of complex rotary wing configurations such the tilt rotor or compound helicopter by minimizing interferences and maximizing their aerodynamic performance.",
            items: [],
          },
          {
            id: 2,
            title: "Rotor Blade Performance",
            shortDescription:
              "Expertise in the estimation of the blade performance of helicopters and rotary wing aircrafts.",
            image: competence13,
            longDescription:
              "Expertise in the estimation of the blade performance of helicopters and rotary wing aircrafts.",
            items: [],
          },
        ],
      },
      {
        id: 3,
        title: "Turbomachinery & Propulsion",
        shortDescription:
          "Dream has experience gained through participation in several European funded projects (as part of the Clean Sky 2 programme) and a successful collaboration with the University of Bochum in the analysis, design and optimisation of turbomachinery.",
        image: competence3,
        longDescription:
          "Dream has experience gained through participation in several European funded projects (as part of the Clean Sky 2 programme) and a successful collaboration with the University of Bochum in the analysis, design and optimisation of turbomachinery.",
        items: [
          {
            id: 1,
            title: "Engine Blade Performance",
            shortDescription:
              "Expertise in the estimation of the aero-thermal blade performance of aircraft engines.",
            image: competence9,
            longDescription:
              "Expertise in the estimation of the aero-thermal blade performance of aircraft engines.",
            items: [],
          },
          {
            id: 2,
            title: "Rotor Blade Performance",
            shortDescription:
              "Expertise in the estimation of the blade performance of helicopters and rotary wing aircrafts.",
            image: competence9,
            longDescription:
              "Expertise in the estimation of the blade performance of helicopters and rotary wing aircrafts.",
            items: [],
          },
        ],
      },
      // Add more items as needed
    ],
  },
  {
    id: 2,
    icon: <FaShip />,
    title: "MARINE",
    color: "text-palette2",
    shortDescription:
      "DREAM seeks to improve naval sector by addressing cost, emissions, & materials challenges. It proposes aeronautical technologies for ships & submarines, aiming for enhanced performance & sustainability through hydrodynamic simulations.",
    longDescription:
      "In the naval sector, there are several technological challenges that need to be addressed to reduce the production and operational costs of ships and submarines. These challenges include reducing fuel consumption, lowering polluting emissions, and using more sustainable materials. Currently, there is a strong interest in replacing fossil fuels with new energy carriers. However, doubts remain regarding the size of ships, propulsion systems, and hydrodynamic design methodologies. DREAM aims to contribute to this innovative phase by proposing the use of technologies developed for aeronautical applications that have the potential to enhance the performance of ships and submarines, making naval transport more attractive and less polluting. DREAM has the capabilities and methodologies to perform hydrodynamic and fluid dynamic simulations for conducting design and specialist optimization studies of naval components.",
    items: [
      {
        id: 1,
        title: "Flow Control for Ship Performance",
        shortDescription:
          "Expertise in the development and application of flow control techniques to ships to enhance performance.",
        image: "",
        longDescription:
          "Expertise in the development and application of flow control techniques to ships to enhance performance.",
        items: [],
      },
      {
        id: 2,
        title: "Hull Design",
        shortDescription:
          "Design of efficient hull with minimal hydrodynamic drag and high performance.",
        image: "",
        longDescription:
          "Design of efficient hull with minimal hydrodynamic drag and high performance.",
        items: [],
      },
      {
        id: 3,
        title: "Optimization",
        shortDescription:
          "Optimization of marine components and hull to reduce cavitation effects by using the riblets concept.",
        image: "",
        longDescription:
          "Optimization of marine components and hull to reduce cavitation effects by using the riblets concept.",
        items: [],
      },
      // Add more items as needed
    ],
  },
  {
    id: 3,
    icon: <FaShieldAlt />,
    title: "DEFENSE",
    color: "text-palette3",
    shortDescription:
      "DREAM supports European security through military research, contributing to technological advantage and participating in EDA initiatives and EDF calls.",
    longDescription:
      "Europe's security and interests are increasingly threatened by the ongoing war crises. To discourage the outbreak of new wars, it is necessary to invest in military research to maintain a technological advantage. DREAM takes part in initiatives by the European Defense Agency, participating in various Cap Techs, and in EDF calls, contributing to the military technological strengthening of Italy and Europe.",
    items: [
      {
        id: 1,
        title: "Drones",
        shortDescription:
          "Drones are becoming increasingly important in both military and civilian sectors for surveillance, defense, and monitoring of territories. Efficient and high-performance drone design heavily relies on aerodynamics. DREAM has advanced simulation methods and skills to design, evaluate, and validate the aerodynamic performance of drones.",
        image: competence10,
        longDescription:
          "Drones are becoming increasingly important in both military and civilian sectors for surveillance, defense, and monitoring of territories. Efficient and high-performance drone design heavily relies on aerodynamics. DREAM has advanced simulation methods and skills to design, evaluate, and validate the aerodynamic performance of drones.",
        items: [],
      },
      {
        id: 2,
        title: "Thermal Management",
        shortDescription:
          "The mechanical properties of materials depend on the temperatures they are exposed to. In some cases, such as aeronautical engines or fuel cells, heat dissipation is crucial for their integrity. DREAM is involved in designing heat exchangers that maximize dissipation while minimizing weight and size, as well as evaluating their performance.",
        image: competence17,
        longDescription:
          "The mechanical properties of materials depend on the temperatures they are exposed to. In some cases, such as aeronautical engines or fuel cells, heat dissipation is crucial for their integrity. DREAM is involved in designing heat exchangers that maximize dissipation while minimizing weight and size, as well as evaluating their performance.",
        items: [],
      },
      // Add more items as needed
    ],
  },
  {
    id: 4,
    icon: <FaTools />,
    title: "METHODS & TOOLS",
    color: "text-palette2",
    shortDescription:
      "DREAM has developed in-house and commercial numerical tools for accurate fluid dynamics and structural analysis in aerospace applications, enhancing its capabilities in aircraft and helicopter design.",
    longDescription:
      "Over time, DREAM has developed in-house numerical models and computational methods to solve various fluid dynamic problems with different levels of accuracy. Furthermore, DREAM has acquired perpetual licenses for the utilisation of high-precision commercial numerical tools. These tools can be utilised to calculate compressible and viscous flow fields around aircraft and helicopters, or to conduct finite element analysis of aeronautical components for structural verification.",
    items: [
      {
        id: 1,
        title: "Fluid Dynamics",
        shortDescription: "Click here for more details about methods and tools",
        image: competence16,
        longDescription: "Click here for more details about methods and tools",
        items: [
          {
            id: 1,
            title: "Methods",
            shortDescription: "",
            image: "",
            longDescription: "",
            items: [
              {
                id: 1,
                title: "Aerodynamic shape optimization",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
              {
                id: 2,
                title: "Multi-disciplinary and multi-objective optimization",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 3,
                title: "Aerodynamic aircraft performance",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 4,
                title: "Drag Reduction",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 5,
                title: "Laminar swept wing design",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 6,
                title: "Transition prediction",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 7,
                title: "Boundary layer computations",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 8,
                title: "Passive and Active flow control simulations",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
            ],
          },
          {
            id: 2,
            title: "Tools",
            shortDescription: "",
            image: "",
            longDescription: "",
            items: [
              {
                id: 1,
                title: "Low fidelity tools based on potential methods",
                shortDescription: "",
                image: "",
                longDescription: "",
                urls: [
                  {
                    name: "AVL",
                    url: "https://web.mit.edu/drela/Public/web/avl/",
                  },
                  {
                    name: "PaMS",
                    url: "https://www.fluere.it/",
                  },
                ],
              },
              {
                id: 2,
                title: "Computational Fluid Dynamics (CFD) Simulation Software",
                shortDescription: "",
                image: "",
                longDescription: "",
                urls: [
                  {
                    name: "Ansys Fluids",
                    url: "https://www.ansys.com/products/fluids",
                  },
                  {
                    name: "Su2",
                    url: "https://su2code.github.io/",
                  },
                ],
              },
              {
                id: 3,
                title:
                  "In house multi-disciplinary optimization based on Nash games",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
              {
                id: 4,
                title: "In house 3D laminar boundary layer code (KC-BL code)",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
              {
                id: 5,
                title: "In house Transition prediction tool (LISACode)",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
            ],
          },
        ],
      },

      {
        id: 2,
        title: "Structures",
        shortDescription: "Click here for more details about methods and tools",
        image: competence14,
        longDescription: "Click here for more details about methods and tools",
        items: [
          {
            id: 1,
            title: "Methods",
            shortDescription: "",
            image: "",
            longDescription: "",
            items: [
              {
                id: 1,
                title: "Static Aero-structural analysis",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
              {
                id: 2,
                title: "Structural design",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 3,
                title: "Stress Analysis",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 4,
                title: "Fluid-structure coupling",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
            ],
          },
          {
            id: 2,
            title: "Tools",
            shortDescription: "",
            image: "",
            longDescription: "",
            items: [
              {
                id: 1,
                title: "Ansys Structural Analysis Software",
                shortDescription: "",
                image: "",
                longDescription: "",
                urls: [
                  {
                    name: "Ansys Structural Analysis Software",
                    url: "https://www.ansys.com/products/structures",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        id: 3,
        title: "Mechanical Design",
        shortDescription: "Click here for more details about methods and tools",
        image: competence15,
        longDescription: "Click here for more details about methods and tools",
        items: [
          {
            id: 1,
            title: "Methods",
            shortDescription: "",
            image: "",
            longDescription: "",
            items: [
              {
                id: 1,
                title: "Mechanical design of aeronautical components",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
              {
                id: 2,
                title: "3D CAD design",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 3,
                title: "CAE analysis",
                shortDescription: "",
                image: "",
                longDescription: "",
              },

              {
                id: 4,
                title: "Design of complex wind tunnel models",
                shortDescription: "",
                image: "",
                longDescription: "",
              },
            ],
          },
          {
            id: 2,
            title: "Tools",
            shortDescription: "",
            image: "",
            longDescription: "",
            items: [
              {
                id: 1,
                title: "Ansys SpaceClaim 3D Modeling Software",
                shortDescription: "",
                image: "",
                longDescription: "",
                urls: [
                  {
                    name: "Ansys SpaceClaim 3D Modeling Software",
                    url: "https://www.ansys.com/it-it/products/3d-design/ansys-spaceclaim",
                  },
                ],
              },
            ],
          },
        ],
      },

      // Add more items as needed
    ],
  },
  {
    id: 5,
    icon: <FaDesktop />,
    title: "SERVICES",
    color: "text-palette3",
    shortDescription:
      "DREAM provides diverse services including precise numerical analyses, utilizing both commercial and proprietary codes, as well as organizing and supporting experimental wind tunnel test campaigns for clients.",
    longDescription:
      "Dream offers its customers different types of services, ranging from accurate numerical analyses, both in the thermo-fluid dynamic and structural fields (not only through the use of commercial or open source codes, but also through the use of in-house developed codes for ad hoc needs), to the organisation of experimental test campaigns in wind tunnels, with support during the execution of the tests. ",
    items: [
      {
        id: 1,
        title: "Low and high fidelity numerical simulations",
        shortDescription: "service",
        image: "",
        longDescription: "",
        items: [],
      },
      {
        id: 2,
        title: "Wing Laminar Flow Design",
        shortDescription: "service",
        image: "",
        longDescription: "",
        items: [],
      },
      {
        id: 3,
        title: "Boundary layer computations",
        shortDescription: "service",
        image: "",
        longDescription: "",
        items: [],
      },
      {
        id: 4,
        title: "Static structural analysis and stress computations",
        shortDescription: "service",
        image: "",
        longDescription: "",
        items: [],
      },
      {
        id: 5,
        title: "CAD design",
        shortDescription: "service",
        image: "",
        longDescription: "",
        items: [],
      },
      {
        id: 6,
        title: "Preparation of research proposals for funded projects",
        shortDescription: "service",
        image: "",
        longDescription: "",
        items: [],
      },
      // Add more items as needed
    ],
  },
];

export default competencesData;
